module.exports = __webpack_public_path__ + "media/images/photos/great-britain-9546f3a594fb1412965d9299d6fb2a22.jpg";